import { render, staticRenderFns } from "./homeworktest.vue?vue&type=template&id=535d2d24&scoped=true"
import script from "./homeworktest.vue?vue&type=script&lang=js"
export * from "./homeworktest.vue?vue&type=script&lang=js"
import style0 from "./homeworktest.vue?vue&type=style&index=0&id=535d2d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535d2d24",
  null
  
)

export default component.exports